import { map } from 'rxjs';
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AddAccountantUsersCompanyEndPoient } from "src/app/Data/service/global.service";
import { HttpHelpService } from "src/app/Data/service/http-help.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-company-employee",
  templateUrl: "./company-employee.component.html",
  styleUrls: ["./company-employee.component.scss"]
})

export class CompanyEmployeeComponent implements OnInit {
  curentLang:string="";
  layoutVersion:any;
  userRegistId:any = JSON.parse(localStorage.getItem('user_id'));
  merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  user_type = JSON.parse(localStorage.getItem('user_type'));
  officeIdNumber =JSON.parse(localStorage.getItem('office_id'));
  company_ID:any;
  companyUUid: any;
  id: any;
  uuid: any;
  term:any;
  p: any;
  employeeData:any=[];
  
  addAccountantUserCompanyForm:FormGroup;
  Permision_id:any
  userData:any=[];
  rowId:number;

  constructor(
    private spinner: NgxSpinnerService ,
    public translate:TranslateService ,
    private service:HttpHelpService  ,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute
  ) 
  { 
    this.curentLang = localStorage.getItem('curentLang');
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
    this.user_type = JSON.parse(localStorage.getItem('user_type'));
    this.officeIdNumber = JSON.parse(localStorage.getItem('office_id')); 
    this.userRegistId  =JSON.parse(localStorage.getItem('user_id'));
    this.uuid = this.activatedRoute.snapshot.params['id'];
 
    this.addAccountantUserCompanyForm = new FormGroup({
      companyUser: new FormControl([] , Validators.required),   
      office_id: new FormControl(this.officeIdNumber),
      company_id: new FormControl(this.id),
      created_by: new FormControl(this.userRegistId),
    });
      
  };

  getCompanyIdByUuid(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.service.getCompanyIdByUuid(this.uuid).subscribe({
        next: res => {
          this.id = res.company_id;
           resolve();
          this.getAllUserAssesToCompany()
        },
        error: error => {
          Swal.fire({
            icon: 'error',
            title: this.curentLang === 'ar' ? 'فشل في الحصول على معلومات الشركة' : (this.curentLang === 'en' ? 'Failed to get company information' : 'נכשל בהשגת מידע על החברה')
          });
          reject(error);
        }
      });
    });
  };

  getAllUserAssesToCompany() {
    this.spinner.show();
    this.service.getAllUserAssesToCompany(this.officeIdNumber, this.id).subscribe({
      next: res => {
        this.employeeData = res.map(item => ({
          ...item,
          formattedPhoneNumber: this.formatPhoneNumber(item.user.phone_number)
        }));
        
        if (this.employeeData && this.employeeData.length > 0) {
          this.Permision_id = this.employeeData[0].permission_id;
        }
        
        this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  }
  
  

  formatPhoneNumber(phoneNumber: string): string {
    // Remove any non-digit characters except '+'
    const cleaned = phoneNumber.replace(/[^ \d]/g, '');
  
    // Ensure the number ends with '+'
    if (!cleaned.endsWith('+')) {
      return `${cleaned}+`;
    }
  
    return cleaned;
  };

  openXl(content2:any) {
    this.modalService.open(content2, { size: 'md'});
  };

  onCompanyMerchantChange(event) {
    this.addAccountantUserCompanyForm.patchValue({
      companyUser: event
      
    });
  };

  getALLUsersByBasedToken() {
    this.spinner.show();
    this.service.getALLUsersByBasedToken().subscribe({
      next: res => {
        this.userData = res;
          
         this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
      }
    });
  };

  addedAccountingUserCompany() {
    if (this.addAccountantUserCompanyForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول' : (this.curentLang === 'en' ? 'Please fill all fields' : (this.curentLang === 'he' ? 'בבקשה תמלא את כל השדות' : ''))
      });
      return;
    } else {
      const companyUsers = this.addAccountantUserCompanyForm.value.companyUser;
       
      const models = companyUsers.map(companyUser => ({
        office_id: Number(this.officeIdNumber),
        company_id: Number(this.id),
        permission_id: Number(this.Permision_id),
        user_id: Number(companyUser.user_id),
        created_by: Number(this.userRegistId),
      }));
  
      this.spinner.show();
      this.service.Post(AddAccountantUsersCompanyEndPoient.POST, models).subscribe((res) => {
        this.spinner.hide();
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
          });
          this.modalService.dismissAll();
          this.getALLUsersByBasedToken();
          this.getAllUserAssesToCompany();
          this.addAccountantUserCompanyForm.reset();
        } else {
          let errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
          Swal.fire({
            icon: 'error',
            title: errorMessage
          });
        }
      });
    }
  };

  openVerticallyCentered(dataDeleted:any) {
    this.modalService.open(dataDeleted, { centered: true });
  };

  getId(id:number)
  {
     this.rowId = id ;
   
  };
  deleteAccessCompanyForUser() {

    this.service.deleteOnAccess(this.rowId).subscribe(({
      next:res=> {
        
        Swal.fire({
          icon: 'success',
          title: this.curentLang === 'ar' ? 'تم حذف الشركة الموجودة لدي المستخدم بنجاح ' : (this.curentLang === 'en' ? ' The user is existing company has been successfully deleted' : 'החברה הקיימת של המשתמש נמחקה בהצלחה'),
        })
        this.getALLUsersByBasedToken();

        this.getCompanyIdByUuid()
            this.modalService.dismissAll()
      },
      error:err =>{
        Swal.fire(err)
      }
    }))
  };

  ngOnInit() {
  //  this.getAllUserAssesToCompany( );
  this.getALLUsersByBasedToken();

   this.getCompanyIdByUuid()
   this.layoutVersion = localStorage.getItem("layout_version");
   if (this.layoutVersion == null || this.layoutVersion == undefined) {
     localStorage.setItem("layout_version", "light-only");
     this.layoutVersion= "light-only"; 
   } else {
     this.layoutVersion = localStorage.getItem("layout_version"); 
     if (this.layoutVersion === "dark-only") {
       document.body.classList.add("dark-only");
     } else {
       document.body.classList.add("light-only");

     }
   }
   this.curentLang = localStorage.getItem('curentLang');
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));
    this.user_type = JSON.parse(localStorage.getItem('user_type'));
    this.officeIdNumber = JSON.parse(localStorage.getItem('office_id'));    

  };
}
